
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "trackEvent",
      resolverType: "mutation",
      routePath: "/trackEvent",
      httpMethod: "POST",
    });
  